import { Checkbox, Form, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { edAttrField } from "../../pages/ManagementPage/Obj2Tab/EdAttribute";
import { MassAttrEditSettingsStore } from "./MassEditSettingsStore";

interface PropsMassAttrEditSettings {
  store: MassAttrEditSettingsStore;
}

export const MassAttrEditSettings: React.FC<PropsMassAttrEditSettings> =
  observer(({ store }) => (
    <Form.Item
      valuePropName="checked"
      name={[edAttrField.massReplacement, "isActive"]}
    >
      <Checkbox disabled={!store.canMassEdit || store.loading}>
        <Spin spinning={store.loading}>Разрешить массовую замену значений</Spin>
      </Checkbox>
    </Form.Item>
  ));
